const UPDATE_APP_STORE = 'update-app-store';

export { UPDATE_APP_STORE };
